import { useContext } from 'react'

import { SearchFormProps } from '@awaze/design-system.compositions.search-form'
import {
  DataLayerEventType,
  DataLayerFactory,
  TmsContext,
} from '@awaze/mfe-common.contexts.tms'

import { dataLayerErrorHandler } from '../../../utils/dataLayerErrorHandler'

export const useSearchSelectionEvent = (): {
  handleDestinationSelection: SearchFormProps['onDestinationSelectionEvent']
  handleDateSelection: SearchFormProps['onDateSelectionEvent']
  handleGuestSelection: SearchFormProps['onGuestSelectionEvent']
  handleSearchSelectionStart: SearchFormProps['onSearchSelectionStart']
} => {
  const tms = useContext(TmsContext)

  const handleDestinationSelection: SearchFormProps['onDestinationSelectionEvent'] =
    (payload) => {
      const { source, searchTerm } = payload
      if (!source) {
        return
      }
      new DataLayerFactory()
        .getEvent(DataLayerEventType.SearchSelectionMade)
        .update(
          tms,
          {
            searchOptionKey: 'destination',
            searchOptionValue: source,
            searchTerm,
          },
          dataLayerErrorHandler,
        )
    }

  const handleDateSelection: SearchFormProps['onDateSelectionEvent'] = (
    payload,
  ) => {
    const { field } = payload

    if (!field) {
      return
    }
    new DataLayerFactory()
      .getEvent(DataLayerEventType.SearchSelectionMade)
      .update(
        tms,
        {
          searchOptionKey: 'date',
          searchOptionValue: field,
        },
        dataLayerErrorHandler,
      )
  }

  const handleGuestSelection: SearchFormProps['onGuestSelectionEvent'] = (
    payload,
  ) => {
    const { field } = payload
    if (!field) {
      return
    }
    new DataLayerFactory()
      .getEvent(DataLayerEventType.SearchSelectionMade)
      .update(
        tms,
        {
          searchOptionKey: 'guest',
          searchOptionValue: field,
        },
        dataLayerErrorHandler,
      )
  }

  const handleSearchSelectionStart: SearchFormProps['onSearchSelectionStart'] =
    (payload) => {
      const { searchOptionKey } = payload
      if (!searchOptionKey) {
        return
      }
      new DataLayerFactory()
        .getEvent(DataLayerEventType.SearchSelectionStart)
        .update(
          tms,
          {
            searchOptionKey,
          },
          dataLayerErrorHandler,
        )
    }

  return {
    handleDestinationSelection,
    handleDateSelection,
    handleGuestSelection,
    handleSearchSelectionStart,
  }
}
